import type { ReactNode } from "react";

/**
 * Titelzeile der Seitentypen T2 (Liste) und T3 (Brett, Zeitleiste): Titel, optional eine Kurzbeschreibung, rechts der
 * Platz für die Primäraktion bzw. die Werkzeugleiste. Ein Kopf je Seitentyp (PM Paket 3a, B7-2, Betreiber 11.10.2026):
 * gleicher Abstand nach unten, keine Trennlinie. Der Seitentitel ist das einzige `h1` der Seite.
 * Ob die Aktion erscheint, entscheidet der Aufrufer mit derselben Prüfung wie die Zielseite (r110).
 */
export function SeitenTitelzeile({
  titel,
  kurzbeschreibung,
  zusatz,
  titelZusatz,
  titelEbene = 1,
  children,
}: {
  titel: string;
  /**
   * Überschriftenebene des Titels: 1 (Standard, das einzige `h1` der Seite) oder 2, wenn die Seite ihr `h1` schon anderswo trägt (Leiste
   * „bearbeiten“/„Vorschau“ unter dem Bereichskopf, Nachzug 20.10.2026), 3 im Seitenpanel (dessen Titel ist `h2`). Nur die Ebene ändert
   * sich, nicht das Aussehen.
   */
  titelEbene?: 1 | 2 | 3;
  kurzbeschreibung?: string;
  /**
   * Pille oder Zustandszeichen unmittelbar neben dem Titel (Live-Gestaltung C, Verbindungsanzeige „Live“, Betreiber 17.10.2026 am Bild); additiv,
   * der Titel bleibt das einzige `h1`.
   */
  titelZusatz?: ReactNode;
  /** Ruhiger Zusatz unter der Kurzbeschreibung (z. B. ein Übergangslink); additiv, ersetzt keine Aktion. */
  zusatz?: ReactNode;
  /** Primäraktion oder Werkzeugleiste (rechts, ab `sm` rechtsbündig). */
  children?: ReactNode;
}) {
  const Ueberschrift = titelEbene === 3 ? "h3" : titelEbene === 2 ? "h2" : "h1";
  return (
    <>
      {/* Preline: navigation-and-layout/navigation-and-layout-sub-titles-footers/navigation-and-layout-cat-title-bars/subtitle-and-navigation-buttons */}
      {/* Abweichung AW-021: ohne Überzeile und Vor-/Zurück-Knöpfe, Kurzbeschreibung statt Untertitel, freier Aktions-Slot in einer flex-wrap-Zeile */}
      <div className="flex flex-wrap justify-between items-center gap-y-1 gap-x-5">
        <div>
          {/* Abweichung AW-112 (2): Pille neben dem Titel (Verbindungsanzeige der Live-Fläche) */}
          {titelZusatz ? (
            <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
              <Ueberschrift className="text-lg md:text-xl font-semibold text-foreground">{titel}</Ueberschrift>
              {titelZusatz}
            </div>
          ) : (
            <Ueberschrift className="text-lg md:text-xl font-semibold text-foreground">{titel}</Ueberschrift>
          )}
          {kurzbeschreibung && <p className="text-sm text-muted-foreground-1">{kurzbeschreibung}</p>}
          {zusatz}
        </div>
        {children}
      </div>
    </>
  );
}
